import React from "react";
import {
  FiHeart,
  FiUsers,
  FiShield,
  FiCheckCircle,
  FiSmartphone,
  FiAward,
} from "react-icons/fi";

import heroImg from "../../assets/img/couple3.jpg";
import logo from "../../assets/img/logo.png";
import PageCount from "../../component/utils/PageCount";

function AboutUs() {
  return (
    <div className="about-page">

      <PageCount  pageName = {"About"}/>

      {/* ⭐ HERO SECTION */}
      <section className="about-hero">
        <div className="hero-left">
          <h1>
            About <span>Soulsathi.com</span>
          </h1>
          <p className="subtitle">
            India’s Most Trusted Matrimony Platform for Genuine Matches &
            Meaningful Connections
          </p>
          <p>
            Soulsathi.com is a modern matrimonial platform designed to help
            individuals and families find <strong>verified, compatible, and trusted</strong>
            life partners. With advanced matchmaking technology, privacy-first
            features, and highly authentic profiles, we make your search for a
            soulmate simple, safe, and successful.
          </p>
        </div>

        <div className="hero-right">
          <img src={heroImg} alt="Happy Couple Matrimonial" />
        </div>
      </section>

      {/* ⭐ OUR STORY */}
      <section className="story-section">
        <h2>
          Our <span>Story</span>
        </h2>
        <p>
          Soulsathi was created with one powerful mission — to bring trust,
          authenticity, and meaningful connections back into the Indian
          matrimonial world. While most platforms focus on quantity, we focus on
         <strong> quality, compatibility, and emotional alignment</strong>.
        </p>
        <p>
          Today, thousands of individuals and families rely on Soulsathi.com
          for <strong>safe matchmaking</strong>, modern search filters, professional support,
          and family-friendly features. Whether you're looking for community-based
          matches, caste-preferred partners, or modern compatibility-based
          matches — Soulsathi serves every Indian’s matchmaking needs.
        </p>
      </section>

      {/* ⭐ WHY CHOOSE US SECTION */}
      <section className="why-choose-section">
        <h2>
          Why <span>Choose Us?</span>
        </h2>

        <div className="why-grid">
          <div className="why-item">
            <FiShield className="icon" />
            <h3>100% Verified Profiles</h3>
            <p>
              Every profile is screened through mobile verification, document
              checks, and AI-based authenticity scoring to ensure a <strong>genuine and
              safe matchmaking experience</strong>.
            </p>
          </div>

          <div className="why-item">
            <FiHeart className="icon" />
            <h3>Smart Compatibility Matching</h3>
            <p>
              Our compatibility algorithm matches profiles based on lifestyle,
              values, personality, education, interests, and preferences —
              increasing the chances of <strong>successful long-term relationships</strong>.
            </p>
          </div>

          <div className="why-item">
            <FiUsers className="icon" />
            <h3>Trusted by Families</h3>
            <p>
              Soulsathi is built for both individuals and families. Parents can
              manage profiles, send requests, and browse matches with full
              transparency and safety controls.
            </p>
          </div>

          <div className="why-item">
            <FiSmartphone className="icon" />
            <h3>Modern & Easy to Use</h3>
            <p>
              Clean design, powerful search filters, instant chat, and smooth
              navigation ensure a delightful and convenient <strong>matrimonial search</strong>
              experience for everyone.
            </p>
          </div>
        </div>
      </section>

      {/* ⭐ PLATFORM HIGHLIGHTS */}
      <section className="highlights-section">
        <h2>
          Platform <span>Highlights</span>
        </h2>

        <div className="highlight-grid">
          <div className="highlight-item">
            <FiCheckCircle className="icon" />
            <h3>Profile Privacy Control</h3>
            <p>Show your photos and details only to people you approve.</p>
          </div>

          <div className="highlight-item">
            <FiAward className="icon" />
            <h3>AI-Based Match Suggestions</h3>
            <p>Personalized daily match suggestions to speed up your search.</p>
          </div>

          <div className="highlight-item">
            <FiShield className="icon" />
            <h3>Secure Communication</h3>
            <p>Built-in chat system with safety moderation and privacy rules.</p>
          </div>

          <div className="highlight-item">
            <FiUsers className="icon" />
            <h3>Community & Religion Filters</h3>
            <p>Find matches based on your community, culture, and values.</p>
          </div>
        </div>
      </section>

      {/* ⭐ OUR MISSION, VISION & VALUES */}
      <section className="mission-vision-section">
        <div className="mv-card">
          <h3>Our Mission</h3>
          <p>
            To connect hearts and families through a <strong>safe, transparent, and
            technology-driven matrimonial platform</strong> that values trust and
            compatibility.
          </p>
        </div>

        <div className="mv-card">
          <h3>Our Vision</h3>
          <p>
            To become India’s most reliable and compassionate matchmaking brand,
            helping millions find lifelong partners with confidence and comfort.
          </p>
        </div>

        <div className="mv-card">
          <h3>Our Values</h3>
          <p>
            Trust, Respect, Privacy, Integrity, Family.  
            These five values define how Soulsathi operates and supports its users.
          </p>
        </div>
      </section>

      {/* ⭐ TRUST INDICATORS */}
      {/* <section className="trust-section">
        <h2>
          Trusted by <span>Thousands</span>
        </h2>

        <div className="trust-stats">
          <div className="stat-box">
            <h3>50,000+</h3>
            <p>Verified Members</p>
          </div>

          <div className="stat-box">
            <h3>10,000+</h3>
            <p>Successful Matches</p>
          </div>

          <div className="stat-box">
            <h3>300+</h3>
            <p>Active Communities</p>
          </div>

          <div className="stat-box">
            <h3>24/7</h3>
            <p>Customer Support</p>
          </div>
        </div>
      </section> */}
    </div>
  );
}

export default AboutUs;
